import { GenericVehicleDetails } from '@finn/ua-vehicle';

const nextWeek = new Date().setDate(new Date().getDate() + 14);
const nextWeekString = new Date(nextWeek).toISOString();

export const COMPACT_SUV_FAKE_PRODUCT = {
  availability: 213,
  available_from_deviation_in_weeks: 0,
  available_from: nextWeekString,
  available_states: null,
  available_terms: [12, 24],
  fake_door_filters: 'renault.mg.hyundai_symbioz_hs_tucson',
  available_to: '2026-02-24',
  related_configs: [],
  color_list: [
    {
      availability: 35,
      availability_date: '2025-06-25',
      brand: 'Hyundai',
      car_id: 'hyundai-tucson-22031-atlaswhiteuni',
      color_hex: '#FFFFFF',
      color_specific: 'Schwarz, Weiß oder Silber',
      desktop_sorting: 1198534,
      id: 'Weiß',
      model: 'Tucson',
      picture_front_url:
        'https://res.cloudinary.com/finn-auto/image/upload/v1748434459/category-compactSuv4.png',
      pricing: [517],
      sorting: '2025-06-25-22031',
      uid: 22031,
    },
  ],
  downpayment_prices: {
    available_price_list: {
      b2c_12: 319,
      b2b_12: 264,
      b2c_24: 279,
      b2b_24: 239,
    },
    msrp: 55100,
    extra_km_price: 0.35,
    extra_500: 0,
    extra_1000: 19,
    extra_1500: 89,
    extra_2000: 159,
    extra_2500: 229,
    extra_3000: 299,
    extra_4000: 439,
    extra_5000: 579,
    downpayment_fixed_amount: 1500,
    downpayment_discount_percentage: 3,
  },
  price: {
    available_price_list: {
      b2c_6: 803,
      b2b_6: 675,
      b2c_12: 571,
      b2b_12: 480,
      b2c_18: 539,
      b2b_18: 453,
      b2c_24: 527,
      b2b_24: 443,
      b2c_36: 321,
      b2b_36: 265,
    },
    msrp: 55100,
    extra_km_price: 0.35,
    b2c_6: 803,
    b2b_6: 675,
    b2c_12: 571,
    b2b_12: 480,
    b2c_18: 539,
    b2b_18: 453,
    b2c_24: 527,
    b2b_24: 443,
    extra_500: 0,
    extra_1000: 19,
    extra_1500: 89,
    extra_2000: 159,
    extra_2500: 229,
    extra_3000: 299,
    extra_4000: 439,
    extra_5000: 579,
  },
  default_term: 24,
  default_downpayment_term: 24,
  availability_by_term: {
    '12': {
      available_from: nextWeekString,
      available_to: '2026-02-24T00:00:00.000Z',
      deviation_in_weeks: 0,
    },
    '24': {
      available_from: nextWeekString,
      available_to: '2026-02-24T00:00:00.000Z',
      deviation_in_weeks: 0,
    },
  },
  brand: {
    id: 'Hyundai',
    picture: {
      filename: 'Hyundai.svg',
      size: 2095,
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/ua_main_restapi_de/brands/logo/OAR57R.svg',
      type: 'image/svg+xml',
    },
    helper_brand_logo: {
      filename: 'Hyundai.svg',
      size: 2095,
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/ua_main_restapi_de/brands/logo/OAR57R.svg',
      type: 'image/svg+xml',
    },
  },
  cartype: 'SUV',
  co2emission: 158,
  co2_class: 'F',
  color: {
    color_hex: '#000000',
    id: 'Schwarz',
    specific: 'Schwarz, Weiß oder Silber',
  },
  config: {
    link: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/configs/attachment/Rf3QPj.pdf',
    name: 'attachment.pdf',
  },
  config_drive: 'Allrad',
  config_hitch: null,
  config_id: 22032,
  consumption: null,
  consumption_city: null,
  consumption_highway: null,
  delivery_options: 'delivery',
  depreciation: null,
  description: 'Renault Symbioz oder MG HS',
  doors: '5',
  efficiency_class: null,
  efficiency_image: null,
  energy_class_file: null,
  engine: 'Oder ähnlich',
  equipment: {
    multimedia:
      'Krell Audio-Anlage Digitalradio٫ Touch Screen und Farbdisplay, Media-Anschlüsse USB vorne٫ Anzahl USB vorne: 1٫ Anzahl USB hinten: 0 und Anzahl USB 3. Reihe: 0',
    safety:
      'ABS, Isofix, Überholsensor aktiv ohne Blinken, Crash Warnsystem aktiviert Sicherheitsgurte٫ aktiviert Bremslicht٫ Müdigkeitswarnung٫ automatische Notbremsung٫ Bremst bei niedriger Geschwindigkeit Mindestgeschw. Zur Aktivierung: 10 km/h Fußgängerschutz٫ visuelle/akustische Warnung٫ einstellbarer Abstand٫ Funktion über 130 km/h 78 mph٫ Funktion über 50 km/h 30 mph٫ Funktion unter 50 km/h 30 mph und umfasst das Abbiegen an Kreuzungen, Autonomes Fahren 2 - teilautomatisiert٫ aktive Spurkontrolle und Autobahn Assistent',
    comfort:
      'Geschwindigkeitsregelanlage mit adaptive Geschwindigkeitsregelanlage stop & go Funktion und adaptive Geschwindigkeitsregelanl. Karte, Geregelter  Vierradantrieb mit Bergabfahrhilfe, Navigationssystem, Sprachbedienung nein, Bluetooth, Mobiltelefonintegration Apple CarPlay٫ Android Auto',
  },
  equipment_delimiter: ', ',
  equipment_line: 'Oder ähnlich',
  equipment_packages: null,
  ev_range: null,
  financing_type: 'abs_2',
  fuel: 'Benzin oder Diesel',
  gearshift: 'Automatik oder Manuell',
  gross_capitalized_cost: null,
  has_hitch: 'false',
  has_real_pictures: false,
  id: 'category-compact-suv',
  indexable: true,
  model: 'Tucson',
  model_year: '2025',
  offer_type: 'subscription',
  picture: {
    url: 'https://res.cloudinary.com/finn-auto/image/upload/v1748434459/category-compactSuv4.png',
  },
  pictures: [
    {
      url: 'https://res.cloudinary.com/finn-auto/image/upload/v1748434459/category-compactSuv4.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/24OVGZ.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/WUl8gf.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/AO-GRr.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/_kyheY.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/7UjBr4.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/vOJ6Bo.png',
    },
  ],
  power: 185,
  product_desktop_sorting: 1793490,
  product_group: ['b2b'],
  product_label: {
    label: null,
    label_color: null,
    label_inverted: null,
    label_text_color: null,
  },
  product_path: null,
  product_stock_preorder: null,
  product_stock_total: 213,
  product_stock_webflow: 213,
  purchasing_deal_name: null,
  recurrent_payment_method_list: ['stripe_credit_card', 'stripe_debit_sepa'],
  residual_values: null,
  seats: '5',
  seo_canonical_product_id: null,
  single_payment_method_list: ['stripe_credit_card', 'stripe_debit_sepa'],
  source: 'blue_dragon',
  states_stock: null,
  tires: 'all_season',
  trim_name: 'Oder ähnlich',
  uid: 22032,
} as unknown as GenericVehicleDetails;
